import ApiClient from '../ApiClient';
import { NiceResponse } from '../dto/NiceResponse';
import { SubmissionWithDetails, SubmissionDetails, ReviewAnswer } from '../../models/assignments';
import { ReviewListParams, GradeRequest } from './dto/ReviewRequests.dto';

// Приводит question_snapshot/answer к объекту: MariaDB JSON-колонки иногда
// сериализуются драйвером в строку — на этот случай парсим вручную.
function normalizeAnswer(raw: ReviewAnswer): ReviewAnswer {
  const questionSnapshot = raw.question_snapshot;
  const answer = raw.answer;

  return {
    ...raw,
    question_snapshot: typeof questionSnapshot === 'string'
      ? JSON.parse(questionSnapshot)
      : questionSnapshot,
    answer: typeof answer === 'string' ? JSON.parse(answer) : answer,
  };
}

export class ReviewApi {
  // eslint-disable-next-line no-unused-vars
  constructor(private api: ApiClient) {}

  // Очередь проверки работ. status обязателен: бэк трактует status=''
  // как pending, поэтому фильтр всегда передаём явно.
  // course_id/lesson_id — опциональные фильтры, пустые/undefined в params не включаем.
  // take ограничен бэкендом до 100.
  async list(params: ReviewListParams, skip: number, take: number) {
    const queryParams: {
      status: ReviewListParams['status'];
      skip: number;
      take: number;
      course_id?: string;
      lesson_id?: string;
    } = {
      status: params.status,
      skip,
      take,
    };

    if (params.course_id) {
      queryParams.course_id = params.course_id;
    }

    if (params.lesson_id) {
      queryParams.lesson_id = params.lesson_id;
    }

    const resp = await this.api.client.get<NiceResponse<SubmissionWithDetails[]>>(
      '/review/submissions',
      { params: queryParams },
    );
    return resp.data;
  }

  // Полная работа ученика с ответами для страницы проверки.
  // Нормализует question_snapshot/answer на случай, если бэк отдал их JSON-строкой.
  async get(id: string) {
    const resp = await this.api.client.get<NiceResponse<SubmissionDetails>>(
      `/review/submissions/${id}`,
    );
    const { data } = resp;

    if (data.body) {
      data.body = {
        ...data.body,
        answers: data.body.answers.map(normalizeAnswer),
      };
    }

    return data;
  }

  // Выставить оценку работе (принять/отклонить с фидбеком).
  async grade(id: string, req: GradeRequest) {
    const resp = await this.api.client.put<NiceResponse<string>>(
      `/review/submissions/${id}`,
      { ...req },
    );
    return resp.data;
  }
}
